import React from "react";
import "./Frame1165.css";

function Frame1165() {
  return (
    <div className="frame-116-178">
      <div className="smed-13 valign-text-middle inter-medium-white-18px">SMED</div>
    </div>
  );
}

export default Frame1165;
